import React from 'react';

import arrowIcon from '../../../images/ic_arrow_right.svg';
import arrowStyle from './ArrowRight.style';
import Arrow from '../../Arrows/Arrow';

const ArrowRight = props => <Arrow arrowIcon={arrowIcon} arrowStyle={arrowStyle} {...props} />;

export default ArrowRight;
